import { ua } from "./libs/daijima/ua";
import { gsap, Quart } from "gsap";

export default class Config {
  static instance;

  constructor(caller) {
    // if (caller != Config.getInstance) {
    if (caller != "getInstance") {
      //TODO
      throw new Error(
        "ConfigクラスはSingletonです。getInstance()メソッドを使ってインスタンス化してください。",
      );
    }

    if (Config.instance != null) {
      throw new Error(
        "ConfigクラスはSingletonです。インスタンスはひとつしか生成できません。",
      );
    } else {
      Config.instance = this;
    }

    this.init();
  }

  static getInstance() {
    // if(Config.instance == null) new Config(arguments.callee);
    if (Config.instance == null) new Config("getInstance"); //TODO
    return Config.instance;
  }

  init() {
    this.BP = 800;
    this.ua = ua;
    this.hasTouch = "ontouchstart" in window;
    this.current = "";

    this.scrollY = 0;
    this.pastScrollY = 0;
    this.scrollWrapper = document.querySelector(".scroll-wrapper");
    this.ASSETS_PATH = "/bc/c/bicidea/assets/";

    /*
      カテゴリー
        01 新商品
        02 デスク
        03 リビング
        04 キッチン
        05 ビューティー・ヘルスケア
        06 モバイル
        07 ベーシック
        08 シーズン
     */

    this.productList = [
      //1
      // {
      //   id: 0,
      //   pickup: false,
      //   categories: [3, 7],
      //   copy: "新開発！引っかけ刃が直接見える！透明アダプタで簡単取付",
      //   tit: "調光機能付きLEDシーリングライト",
      //   key_color: "#E60012",
      //   text_color: "white",
      // },
      //7
      // {
      //   id: 0,
      //   pickup: false,
      //   categories: [5],
      //   copy: "乗るだけで9つの項目を同時にチェック",
      //   tit: "体重体組成計",
      //   key_color: "#37b48D",
      //   text_color: "white",
      // },
      //13
      {
        id: 24,
        pickup: true,
        categories: [7],
        copy: "普段使いにも万が一の時にも安心な乾電池",
        tit: "【7年保存可能】アルカリ乾電池",
        key_color: "#E60012",
        text_color: "white",
      },
      //14
      {
        id: 25,
        pickup: true,
        categories: [7],
        copy: "長期保管でも安心な乾電池",
        tit: "【10年保存可能】アルカリ乾電池",
        key_color: "#555555",
        text_color: "white",
      },
      //15
      {
        id: 11,
        pickup: true,
        categories: [1, 3],
        copy: "干す時間短縮！すぐ乾く",
        tit: "洗濯物を干す人のためのタオル",
        key_color: "#E0C987",
        text_color: "black",
      },
      //16
      {
        id: 12,
        pickup: true,
        categories: [1, 3],
        copy: "ガンガン洗えてへたりにくい",
        tit: "乾燥機を使う人のためのタオル",
        key_color: "#99AEB5",
        text_color: "black",
      },
      //17
      {
        id: 13,
        pickup: true,
        categories: [1, 5, 3],
        copy: "タオルを変える、髪が変わる",
        tit: "髪をいたわる人のためのタオル",
        key_color: "#FCB9CB",
        text_color: "black",
      },
      //18
      {
        id: 14,
        pickup: true,
        categories: [5, 1],
        copy: "髪を乾かす時間をあなたを花やぐ時間に",
        tit: "Karen Bloom Flow Dryer",
        key_color: "#899AEA",
        text_color: "white",
      },
      //19
      {
        id: 15,
        pickup: false,
        categories: [1, 5],
        copy: "ストレートスタイルもカールスタイルもこれ一本！",
        tit: "BI form 2way HAIR IRON",
        key_color: "#5A707B",
        text_color: "white",
      },
      //21
      {
        id: 27,
        pickup: false,
        categories: [4, 7],
        copy: '高火力＆薄型ボディ',
        tit: 'IH調理器',
        key_color: '#E60012',
        text_color: 'white'
      },
      //28
      {
        id: 19,
        pickup: true,
        categories: [2, 6, 1],
        copy: "最大30W・2ポートで2台同時に急速充電",
        tit: "PDアダプター",
        key_color: "#009C96",
        text_color: "white",
      },
      //32
      {
        id: 28,
        pickup: false,
        categories: [4],
        copy: "煮込・低温調理ができる炊飯器",
        tit: "温度調節機能付きマイコンジャー炊飯器 5.5合",
        key_color: "#F39800",
        text_color: "black",
      },
      //37
      // {
      //   id: 0,
      //   pickup: false,
      //   categories: [7, 8],
      //   copy: "全分解で簡単お手入れ。快適空気循環ファン",
      //   tit: "DCサーキュレーター",
      //   key_color: "#E60012",
      //   text_color: "white",
      // },
      //38
      // {
      //   id: 0,
      //   pickup: false,
      //   categories: [3, 7],
      //   copy: '手入れに手間をかけない紙パック式',
      //   tit: 'キャニスター掃除機',
      //   key_color: '#E60012',
      //   text_color: 'white'
      // },
      //40
      // {
      //   id: 0,
      //   pickup: false,
      //   categories: [3, 4],
      //   copy: '「その重み、床に残っていませんか？」置くだけでできる床ケア',
      //   tit: '冷蔵庫『床』傷防止パネル',
      //   key_color: '#22B8C5',
      //   text_color: 'black'
      // },
      //41
      {
        id: 20,
        pickup: false,
        categories: [6, 2, 1],
        copy: "触れて心地いい、清潔な充電ケーブル",
        tit: "USBシリコーンケーブル ヤワラケーブル　USB-C⇔USB-C(PD60W)　0.5m～",
        key_color: "#44D62C",
        text_color: "black",
      },
      //54
      // {
      //   id: 0,
      //   pickup: true,
      //   categories: [1, 3, 8],
      //   copy: "設置できなくても、涼しさをあきらめない",
      //   tit: "ポータブルルームエアコン",
      //   key_color: "#008086",
      //   text_color: "white",
      // },
      //57
      // {
      //   id: 0,
      //   pickup: true,
      //   categories: [1, 3, 8],
      //   copy: "1台4役オールシーズン対応",
      //   tit: "スポットエアコン",
      //   key_color: "#E60012",
      //   text_color: "white",
      // },
      //58
      {
        id: 21,
        pickup: false,
        categories: [1, 2, 5],
        copy: "触れて心地いい、清潔な充電ケーブル",
        tit: "USBシリコーンケーブル ヤワラケーブル　USB-C⇔USB-C(PD100W)　0.5m～",
        key_color: "#E60012",
        text_color: "white",
      },
      //59
      {
        id: 22,
        pickup: false,
        categories: [1, 2, 5],
        copy: "触れて心地いい、清潔な充電ケーブル",
        tit: "USBシリコーンケーブル ヤワラケーブル　USB-A⇔USB-C 0.5m～",
        key_color: "#E60012",
        text_color: "white",
      },
      //60
      // {
      //   id: 0,
      //   pickup: false,
      //   categories: [1, 2, 5],
      //   copy: '触れて心地いい、清潔な充電ケーブル',
      //   tit: 'USBシリコーンケーブル ヤワラケーブル　USB-A to Lightning　0.5m～',
      //   key_color: '#E60012',
      //   text_color: 'white'
      // },
      //61
      {
        id: 23,
        pickup: false,
        categories: [1, 2, 5],
        copy: "触れて心地いい、清潔な充電ケーブル",
        tit: "USBシリコーンケーブル ヤワラケーブル　USB-C to Lightning　0.5m～",
        key_color: "#E60012",
        text_color: "white",
      },
      //62
      {
        id: 17,
        pickup: true,
        categories: [1, 2, 6],
        copy: "よい仕事は、よい姿勢から。",
        tit: "据え置き用 ノートパソコンスタンド",
        key_color: "#00ced1",
        text_color: "black",
      },
      //63
      {
        id: 16,
        pickup: true,
        categories: [1, 3],
        copy: "“持つ・置く・吊るす“で使える、暮らしに寄り添う",
        tit: "3WAYライト allu",
        key_color: "#708090",
        text_color: "white",
      },
      //65
      {
        id: 18,
        pickup: true,
        categories: [1, 6],
        copy: "さっと携帯、ぱぱっと展開",
        tit: "持ち運び用 ノートパソコンスタンド",
        key_color: "#00ced1",
        text_color: "black",
      },
      //66
      {
        id: 1,
        pickup: true,
        categories: [5, 1],
        copy: "誰もが知る名品を、わが家の一台に。",
        tit: "Dyson Supersonic Nural Lite セラミックカーキ",
        key_color: "#0d1207",
        text_color: "white",
      },
      //67
      {
        id: 2,
        pickup: true,
        categories: [1, 3, 8],
        copy: "冬の部屋に、置きたい名品。",
        tit: "アラジン　遠赤グラファイトヒーター 青霞色",
        key_color: "#6e8da4",
        text_color: "white",
      },
      //68
      {
        id: 4,
        pickup: true,
        categories: [8, 1],
        copy: "足元の「ちょっと寒い」に、ちょうどいい。",
        tit: "電気ストーブ",
        key_color: "#E60012",
        text_color: "white",
      },
      //69
      {
        id: 3,
        pickup: true,
        categories: [3, 8],
        copy: "人を感じて、温風オン。離れたら、自動オフ。",
        tit: "セラミックファンヒーター(人感センサー付き)",
        key_color: "#E60012",
        text_color: "white",
      },
      //70
      {
        id: 10,
        pickup: true,
        categories: [3, 8],
        copy: "うるおいは足して、手間は少なく。",
        tit: "超音波加湿器",
        key_color: "#E60012",
        text_color: "white",
      },
      //71
      {
        id: 5,
        pickup: true,
        categories: [3, 8],
        copy: "夜の静けさに、うるおいを。",
        tit: "夜の加湿器　sei　(350ml/h)",
        key_color: "#1a4e73",
        text_color: "white",
      },
      //72
      {
        id: 26,
        pickup: true,
        categories: [3, 8],
        copy: "みんなの部屋に、たっぷりうるおい。",
        tit: "スチーム加湿器　(600ml/h)",
        key_color: "#E60012",
        text_color: "white",
      },
      //73
      {
        id: 6,
        pickup: true,
        categories: [3, 4, 1],
        copy: "解凍も、あたためも、焼く楽しみも。",
        tit: "WANDA with Oven",
        key_color: "#f08300",
        text_color: "black",
      },
      //75
      {
        id: 9,
        pickup: true,
        categories: [1, 3, 8],
        copy: "抱えたくなる、冬のぬくもり。",
        tit: "Night Fall Cafe ソフトウォーマー",
        key_color: "#4f6d90",
        text_color: "white",
      },
      //76
      {
        id: 8,
        pickup: true,
        categories: [8, 1, 3],
        copy: "冬の夜を、好きな一枚で。",
        tit: "Night Fall Cafe ホットブランケット",
        key_color: "#536c5a",
        text_color: "white",
      },
      //77
      {
        id: 7,
        pickup: true,
        categories: [3, 1, 8],
        copy: "床にも、冬のくつろぎ場所を。",
        tit: "Night Fall Cafe ホットラグ(1畳／2畳)",
        key_color: "#b26d5d",
        text_color: "white",
      },
      //79
      {
        id: 29,
        pickup: false,
        categories: [6],
        copy: "端子が変わっても、好きな音を。",
        tit: "オーディオ変換ケーブル Type-C-4極イヤホン端子",
        key_color: "#f4f4f4",
        text_color: "black",
      },
      //81
      {
        id: 30,
        pickup: true,
        categories: [6],
        copy: "大切なレンズと、もっと出かけよう。",
        tit: "Eta レンズ保護フィルター",
        key_color: "#6c5ea7",
        text_color: "white",
      },
    ];

    this.getFormatDate = (date) => {
      const dateArray = String(new Date(date)).split(" ");
      return dateArray[1] + " " + dateArray[2] + ", " + dateArray[3];
    };

    // 3桁カンマ区切りとする
    this.addComma = (num) => {
      var s = String(num).split(".");
      var ret = String(s[0]).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,");
      if (s.length > 1) {
        ret += "." + s[1];
      }
      return ret;
    };

    this.d2r = function (d) {
      return (d * Math.PI) / 180;
    };

    this.r2d = function (r) {
      return (r * 180) / Math.PI;
    };

    this.random = function (min, max) {
      return Math.random() * (max - min) + min;
    };

    /**
     * 線形補間（lerp）関数
     * @param {number} a - 開始値
     * @param {number} b - 終了値
     * @param {number} t - 補間パラメータ（0から1の範囲）
     * @returns {number} 補間された値
     */
    this.lerp = (a, b, t) => {
      // tが0から1の範囲外の場合、範囲内に収める
      t = Math.max(0, Math.min(1, t));
      return a + (b - a) * t;
    };

    this.lockHTML = () => {
      const html = document.documentElement;
      html.classList.add("hidden");
    };

    this.unlockHTML = () => {
      const html = document.documentElement;
      html.classList.remove("hidden");
    };

    this.anchorScroll = function (targetY, dr, ease, cb) {
      if (!dr) dr = 1;
      if (!ease) ease = Quart.easeInOut;
      const obj = { y: window.pageYOffset };
      gsap.killTweensOf(obj);
      gsap.to(obj, dr, {
        y: targetY,
        ease: ease,
        onUpdate: function () {
          window.scrollTo(0, obj.y);
        },
        onComplete: function () {
          if (cb) cb();
        },
      });
    };

    this.addZero = function (str) {
      if (str.length == 1) str = "0" + str;
      return str;
    };

    this.commonMouseOver = (
      target,
      scale = 1.1,
      dr = 0.8,
      ease = "elastic.out(1.7, 0.35)",
    ) => {
      gsap.to(target, {
        scale: scale,
        duration: dr,
        ease: ease,
        overwrite: true,
      });
    };

    this.commonMouseOut = (target) => {
      gsap.to(target, {
        scale: 1,
        duration: 0.4,
        ease: "quart.out",
        overwrite: true,
      });
    };

    this.commonClick = (target, scale = 1.15) => {
      gsap.fromTo(
        target,
        { scale: scale },
        {
          scale: 1,
          duration: 0.8,
          ease: "elastic.out(1.5, 0.4)",
          overwrite: true,
        },
      );
    };

    this.applyIconHoverEffect = (eventTarget, animationTarget) => {
      if (this.hasTouch) return;
      eventTarget.addEventListener("mouseenter", () => {
        const tl = gsap.timeline({ overwrite: true });
        const colorPatterns = [
          ["#E60012", "#22A0DD", "#FFF000"], // 赤・青・黄
          ["#80C037", "#FFF000", "#22A0DD"], // 緑・黄・青
          ["#FFF000", "#5853A0", "#E60012"], // 黄・紫・赤
        ];
        const hoverColors =
          colorPatterns[Math.floor(Math.random() * colorPatterns.length)];
        const dr = 0.06;

        tl.set(animationTarget, { backgroundColor: hoverColors[0] })
          .set(animationTarget, { backgroundColor: hoverColors[1], delay: dr })
          .set(animationTarget, { backgroundColor: hoverColors[2], delay: dr })
          .set(animationTarget, { backgroundColor: hoverColors[0], delay: dr })
          .set(animationTarget, { backgroundColor: hoverColors[1], delay: dr })
          .set(animationTarget, { backgroundColor: "", delay: dr });
      });

      eventTarget.addEventListener("mouseleave", () => {
        gsap.to(animationTarget, {
          backgroundColor: "",
          duration: 0.3,
          overwrite: true,
        });
      });
    };

    this.getRandomColor = () => {
      const rainbowColors = [
        "#80C037",
        "#408D4D",
        "#22A0DD",
        "#5853A0",
        "#E60012",
        "#EF5025",
        "#FFF000",
      ];
      return rainbowColors[Math.floor(Math.random() * rainbowColors.length)];
    };

    this.applyTextHoverEffect = (eventTarget, animationTargets) => {
      if (this.hasTouch) return;

      if (!animationTargets || animationTargets.length === 0) return;
      const dr = 0.07;

      eventTarget.addEventListener("mouseenter", () => {
        animationTargets.forEach((span) => {
          const tl = gsap.timeline({ overwrite: true });

          tl.set(span, { color: this.getRandomColor() })
            .set(span, {
              color: this.getRandomColor(),
              delay: Math.random() * 0.2,
            })
            .set(span, { color: this.getRandomColor(), delay: dr })
            .set(span, { color: this.getRandomColor(), delay: dr })
            .set(span, { color: this.getRandomColor(), delay: dr })
            .set(span, { color: "", delay: dr });
        });
      });

      eventTarget.addEventListener("mouseleave", () => {
        gsap.to(animationTargets, {
          color: "",
          duration: 0.3,
          overwrite: true,
        });
      });
    };
  }
}
